import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Subadmin_rights() {
  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const uId = userId;
  const navigate = useNavigate();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [usernamelist, setUsernameList] = useState([]);
  const [id_value, setSelect] = useState("");

  const [menuList, setMenuList] = useState("");
  const [menuLinkList, setMenuLinkList] = useState("");
  const [isChecked, setIsChecked] = useState([]);

  //console.log("ssss_arrays", isChecked)

  const handleChange = (event) => {
    event.target.checked
      ? setIsChecked([...isChecked, event.target.value])
      : setIsChecked(isChecked.filter((a) => a != event.target.value));
  };

  const HandleUpdate = async () => {
    try {
      isChecked?.map(async (item, index) => {
        let responceRight = await API?.post(
          `/updateSubAdminRights`,
          {
            uid: id_value,
            subid: item,
            username: uId,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        //console.log("sss_result", responceRight?.data?.data);
      });
      toast.success("Rights Updated Successfully !!");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  const referral_API_menu = async () => {
    try {
      let responce = await API?.post(
        `/menulist`,
        {
          username: uId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responce = responce?.data?.data.records;
      console.log("response_menu", responce);
      setMenuList(responce);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  const referral_API_menulink = async () => {
    try {
      let responce = await API?.post(
        `/menulinklist`,
        {
          username: uId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responce = responce?.data?.data.records;
      //console.log("response_menu", responce);
      setMenuLinkList(responce);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  const referral_API_user = async () => {
    try {
      let responce = await API?.post(
        `/usernamelist`,
        {
          username: uId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responce = responce?.data?.data.records;
      //console.log("response", responce);
      setUsernameList(responce);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  useEffect(() => {
    referral_API_menu();
    referral_API_user();
    referral_API_menulink();
  }, []);

  return (
    <div>
      <Navbar />
      <div className="content-page h-100 ">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">Sub Admin Rights</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <form>
                          <div className="form-group">
                            <div className="col-md-12">
                              <div className="col-md-2">
                                <label
                                  style={{ color: "black", marginTop: "10px" }}
                                >
                                  Sub Admin Name
                                </label>
                              </div>
                              <div className="col-md-4">
                                <select
                                  onChange={(e) => setSelect(e.target.value)}
                                  className="form-control in-ip-1"
                                  aria-label=".form-select-sm example"
                                >
                                  <option selected value={""}>
                                    Select Sub Admin
                                  </option>
                                  {usernamelist.map((projectlist) => (
                                    <option
                                      value={projectlist.user_id}
                                      key={projectlist.id}
                                    >
                                      {projectlist.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            {id_value ? (
                              <div className="form-group">
                                {menuList?.map((item, index) => {
                                  return (
                                    <div className="row" key={item.id}>
                                      <div className="col-md-12">
                                        <div className="col-md-4">
                                          <label className="mb15">
                                            {item.name}
                                          </label>
                                          <br />
                                        </div>
                                      </div>
                                      <div className="clearfix"></div>
                                      <div className="col-md-12">
                                        {menuLinkList?.map((litem, lindex) => {
                                          return item.id === litem.main_manu ? (
                                            <div
                                              className="col-md-12"
                                              key={litem.id}
                                            >
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  id="check"
                                                  name="check"
                                                  value={litem.id}
                                                  onChange={handleChange}
                                                />

                                                <span
                                                  style={{ marginLeft: "5px" }}
                                                >
                                                  {litem.name}
                                                </span>
                                              </div>
                                            </div>
                                          ) : (
                                            <div></div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  );
                                })}

                                <div className="col-md-5"></div>
                              </div>
                            ) : null}

                            <div className="text-center">
                              <button
                                onClick={() => HandleUpdate()}
                                type="button"
                                className="btn btn-success"
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Subadmin_rights;
